const NAME = "QUERY_DEFINITION_PAGE";

export default NAME;
